import React, { useState, useEffect } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import Question from 'on_web/components/shared/Question/Question';
import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import UserProfileContext from 'on_web/context/userProfileContext';
import { getHealthQuestions } from 'on_web/helpers/questions';
import {
  setObjectPropsToZero,
  objectHasAllValuesZero,
} from 'on_web/helpers/customHelpers';

import { useTranslation } from 'react-i18next';

function DiseasesStep7(props) {
  const context = React.useContext(UserProfileContext);
  const [selectedItems, setSelectedItems] = useState(
    context && context.userMetaData && context.userMetaData.diseasesData
      ? context.userMetaData.diseasesData
      : []
  );
  const [diseases, setDiseases] = useState(
    context && context.diseases ? context.diseases : null
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();
  const questions1 = getHealthQuestions(selectedItems, diseases, t);

  const onCheckboxChange = (val, checked) => {
    if (checked) {
      if (val === '8') {
        setObjectPropsToZero(diseases);
        setDiseases(diseases);
        setSelectedItems([val]);
      } else {
        setSelectedItems([]);
        if (val === '1') {
          diseases['flu'] = 1;
        } else if (val === '2') {
          diseases['lung_infection'] = 1;
        } else if (val === '3') {
          diseases['strong_allergies'] = 1;
        } else if (val === '4') {
          diseases['autoimmune_issues'] = 1;
        } else if (val === '5') {
          diseases['out_of_breath'] = 1;
        } else if (val === '6') {
          diseases['depression'] = 1;
        } else if (val === '7') {
          diseases['memory_loss_confusion'] = 1;
        }
      }
    } else {
      setSelectedItems(selectedItems.filter(i => i !== val));
      if (val === '1') {
        diseases['flu'] = 0;
      } else if (val === '2') {
        diseases['lung_infection'] = 0;
      } else if (val === '3') {
        diseases['strong_allergies'] = 0;
      } else if (val === '4') {
        diseases['autoimmune_issues'] = 0;
      } else if (val === '5') {
        diseases['out_of_breath'] = 0;
      } else if (val === '6') {
        diseases['depression'] = 0;
      } else if (val === '7') {
        diseases['memory_loss_confusion'] = 0;
      }
    }
  };

  const onClickNext = () => {
    const userMetaData = context ? context.userMetaData : null;

    if (props.onClickNext && userMetaData) {
      userMetaData.diseasesData = selectedItems;
      props.onClickNext(userMetaData, diseases);
    }
  };

  return (
    <React.Fragment>
      <Header />
      {(context == null || context.editMode !== true) && (
        <StepProgressIndicator
          showBasicQuestions={context.showBasicQuestions}
          selectedSlideIx={
            process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 3 : 2
          }
        />
      )}

      <Question
        sectionTitle={t(
          'onboarding.diseasesSection.diseasesStep6.sectionTitle1'
        )}
        checkboxSelection={{ items: questions1, twoColumns: false }}
        deselectAllValue="8"
        onAnswer={(val, checked) => onCheckboxChange(val, checked)}
        instructionAbove={t(
          'onboarding.diseasesSection.diseasesStep6.instructionAbove1'
        )}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={
          selectedItems.length === 0 && objectHasAllValuesZero(diseases)
        }
        editMode={context && context.editMode}
      />
    </React.Fragment>
  );
}

export default DiseasesStep7;
